<div class="support-page-container">
  <app-support class="z-index--1"></app-support>
</div>
